import axios from 'axios'

const axiosInstance = axios.create({
  timeout: 30000
})

axiosInstance.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token')
  if (token && !config.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

axiosInstance.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response?.status === 401 || error.response?.status === 403) {
    sessionStorage.clear()
    window.location.href = '/login'
  }
  return Promise.reject(error)
})

const AxiosUtil = new Proxy(axiosInstance, {
  get(target, prop) {
    if (prop in target) {
      return target[prop]
    }
    if (prop in axios) {
      return axios[prop]
    }
    return undefined
  }
})

export default AxiosUtil